import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IffhsService } from 'src/app/data-services/iffhs.service';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { first } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from 'src/app/data-services/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-club-dashboard-media',
  templateUrl: './club-dashboard-media.component.html',
  styleUrls: ['./club-dashboard-media.component.css']
})
export class ClubDashboardMediaComponent implements OnInit {

  mediaForm: FormGroup;
  id: number;
  countryData: any = {};
  clubData: any = {};
  searchText: any;
  currentUser: any;
  isLoaderVisible = false;
  submitted = false;
  isSubmitted = true;
  errorMessage = '';
  visible = true;
  onChangeValue: string;
  constructor(
    private route: ActivatedRoute,
    private iffhsService: IffhsService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastrService: ToastrService,

  ) { }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.route.queryParams.subscribe(params => this.id = params.id);
    this.getClubProfile();
    this.mediaForm = this.formBuilder.group({
      clubId: [this.id],
      mediaType: ['', Validators.required],
      mediaTitle: ['', Validators.required],
      mediaContent: [''],
      mediaAttachment: ['', Validators.required],
      createdBy: [this.currentUser.success.user.id],

    });
  }
  getClubProfile() {
    const data = {
      clubId: this.id,
    };
    this.iffhsService.getClubProfile(data).subscribe((res: any) => {
      this.clubData = res.club;
      this.countryData = res.country;
      this.isLoaderVisible = false;
    });
  }
  onFileSelect(event) {
    const mediaAttachment = event.target.files[0];
    this.mediaForm.get('mediaAttachment').setValue(mediaAttachment);
  }
  onChange(e) {
    this.onChangeValue = e.target.value || 0;
    console.log(this.onChangeValue);
  }
  onImageSelect(event) {
    const mediaAttachment = event.target.files[0];
    const type = event.target.files[0].type;
    if (type.match(/image\/*/) === null) {
      this.toastrService.error('Only images are supported', 'Message!');
      return;
    }
    this.mediaForm.get('mediaAttachment').setValue(mediaAttachment);

  }
  onVideoSelect(event) {
    const mediaAttachment = event.target.files[0];
    const type = event.target.files[0].type;
    if (type.match(/video\/*/) === null) {
      this.toastrService.error('Only videos are supported', 'Message!');
      return;
    }
    this.mediaForm.get('mediaAttachment').setValue(mediaAttachment);

  }
  get f() { return this.mediaForm.controls; }
  postMedia() {
    this.submitted = true;
    this.isLoaderVisible = true;
    if (this.mediaForm.invalid) {
      return;
    }
    const fd = new FormData();
    fd.append('clubId', this.mediaForm.get('clubId').value);
    fd.append('mediaType', this.mediaForm.get('mediaType').value);
    fd.append('mediaTitle', this.mediaForm.get('mediaTitle').value);
    fd.append('mediaContent', this.mediaForm.get('mediaContent').value);
    fd.append('createdBy', this.mediaForm.get('createdBy').value);
    fd.append('mediaAttachment', this.mediaForm.get('mediaAttachment').value);

    this.iffhsService.addMedia(fd).pipe(first()).subscribe(
      data => {
        this.toastrService.success(this.onChangeValue + ' Added!', 'Message!');
        this.isLoaderVisible = false;
        this.submitted = true;
      },
      error => {
        console.log(error);
        this.toastrService.error('Something went wrong please Try Later!', 'Message!');
        this.isLoaderVisible = false;
      }
    );
    this.mediaForm = this.formBuilder.group({
      clubId: [this.id],
      mediaType: [null],
      mediaTitle: [null],
      mediaContent: [null],
      mediaAttachment: [null],
      createdBy: [this.currentUser.success.user.id],

    });
  }
 
}
